import { html } from '@design.estate/dees-element';
import type { TFormData } from '../elements/00group-form/dees-form/dees-form.js';
import { demoOutput, showDemoResult } from './templates.js';

export interface IDemoWorkspace {
  name: string;
  email: string;
  visibility: { key: string; option: string };
  review: string;
  notifications: boolean;
  activity: boolean;
}

export const workspaceVisibility = [
  { key: 'team', option: 'Team members' },
  { key: 'private', option: 'Only me' },
  { key: 'public', option: 'Anyone with the link' },
];

export const createWorkspace = (): IDemoWorkspace => ({
  name: 'Design studio', email: 'hello@example.com', visibility: workspaceVisibility[0],
  review: '', notifications: true, activity: false,
});

export const updateWorkspace = (current: IDemoWorkspace, data: TFormData): IDemoWorkspace => ({
  name: typeof data.name === 'string' ? data.name : current.name,
  email: typeof data.email === 'string' ? data.email : current.email,
  visibility: workspaceVisibility.find((option) => typeof data.visibility === 'object' && data.visibility !== null && 'key' in data.visibility && option.key === data.visibility.key) ?? current.visibility,
  review: typeof data.review === 'string' ? data.review : current.review,
  notifications: typeof data.notifications === 'boolean' ? data.notifications : current.notifications,
  activity: typeof data.activity === 'boolean' ? data.activity : current.activity,
});

export const workspaceGeneralFields = (data: IDemoWorkspace) => html`
  <dees-input-text key="name" label="Workspace name" .value=${data.name} required></dees-input-text>
  <dees-input-dropdown key="visibility" label="Visibility" .options=${workspaceVisibility} .selectedOption=${data.visibility}></dees-input-dropdown>
  <dees-input-datepicker key="review" label="Next review" .value=${data.review}></dees-input-datepicker>
  <dees-input-toggle key="notifications" label="Desktop notifications" description="Stay up to date when your team needs you." .value=${data.notifications}></dees-input-toggle>`;

export const workspacePrivacyFields = (data: IDemoWorkspace) => html`
  <dees-input-text key="email" label="Contact email" .value=${data.email}></dees-input-text>
  <dees-input-toggle key="activity" label="Share activity" description="Let teammates see when you are available." .value=${data.activity}></dees-input-toggle>`;

export const workspaceForm = (data = createWorkspace(), onSave?: (data: IDemoWorkspace) => void) => html`
  <dees-form class="dees-demo-form" @formData=${(event: CustomEvent<{ data: TFormData }>) => {
    const saved = updateWorkspace(data, event.detail.data);
    onSave?.(saved);
    showDemoResult(event.currentTarget as Element, saved);
  }}>
    ${workspaceGeneralFields(data)}
    <dees-form-submit type="accent" text="Save workspace" icon="lucide:check"></dees-form-submit>
  </dees-form>
  ${demoOutput('Changes stay in this preview.')}`;
